var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchase-detail-recode-list"},[(_vm.handleList && _vm.handleList.length > 0)?_c('div',{staticClass:"handle-list"},_vm._l((_vm.handleList),function(item){return _c('div',{key:item.id,staticStyle:{"line-height":"30px"}},[_vm._v(" "+_vm._s(_vm.getMsg(item))+" ")])}),0):_c('div',{staticClass:"no-data"},[_vm._v("暂无签收记录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }